import React from "react";
import { useParams, Link } from "react-router-dom";
import Header from "@/components/Header";

const MODULES = {
  "debate-mentor": {
    name: "Debate Mentor",
    blurb: "Stage your arguments against rigorous counter-positions. Stress-test your reasoning the way a worthy interlocutor would.",
  },
  "research-mentor": {
    name: "Research Mentor",
    blurb: "Pursue a question across sources. Track what you have read, what contradicts, and where understanding remains thin.",
  },
  "writing-mentor": {
    name: "Writing Mentor",
    blurb: "Move from notes to a draft. Develop your own voice with feedback that respects your argument.",
  },
  "library-recommendations": {
    name: "Library Recommendations",
    blurb: "Borrow-list suggestions from local libraries and public-domain archives, tuned to what you are working on.",
  },
};

export default function ComingSoon() {
  const { slug } = useParams();
  const mod = MODULES[slug] || { name: "Coming Soon", blurb: "" };
  return (
    <div className="min-h-screen bg-forge-900 text-forge-100">
      <Header />
      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-20 sm:py-28">
        <div className="text-[10px] tracking-[0.4em] uppercase text-gold-500 mb-4">Coming Soon</div>
        <h1 className="font-serif text-4xl sm:text-6xl tracking-tight mb-6" data-testid="coming-soon-title">{mod.name}</h1>
        <p className="font-reading text-lg text-forge-100/70 leading-relaxed max-w-2xl mb-10">{mod.blurb}</p>
        <Link
          to="/dashboard"
          className="inline-block px-5 py-2.5 border border-white/15 hover:border-ember-500 hover:text-ember-400 text-sm tracking-wide rounded-sm transition-all"
        >
          ← Back to your study
        </Link>
      </main>
    </div>
  );
}
